// extracted by mini-css-extract-plugin
module.exports = {"capacity":"_1p4PYblWJiGdR1CqeDS1Gd","spread":"_22DZzyeUSuwOTpTz-0F5TC","stacked":"lin3lZ_T5OttWqVbyMMB1"};